import http from '@/common/utils/http-common';
import Announce from '@/types/Announce.type';

class AnnounceDataService {
  getAll() {
    return http.get('/announces');
  }

  getMySelf() {
    return http.get('/announces/my-self');
  }

  get(id: string) {
    return http.get(`/announces/${id}`);
  }

  create(data: Announce) {
    return http.post('/announces', data);
  }

  update(data: Announce, id: any) {
    return http.put(`/announces/${id}`, data);
  }

  delete(id: any) {
    return http.delete(`/announces/${id}`);
  }
}

export default new AnnounceDataService();
